import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import infoBtn from "assets/images/info_btn.svg";
import OrganisationAuditWindow from "components/Audit/OrganisationAuditWindow";
import Status from "components/General/Status";
import SvgBtn from "components/General/SvgBtn";
import { highlightMatchInString } from "helpers/GeneralHelpers";
import { useState } from "react";
import OrganisationTagsComponent from "./OrganisationTags";
import Avatar from "components/UI/Avatar";

const OrganisationItemComponent = ({
  organisation,
  onTagSelected,
  searchValue,
}) => {
  const navigate = useNavigate();
  const manageProfileUrl = `/organisations/${organisation.organisationId}`;
  const viewOrganisationAccountsUrl = `/organisations/${organisation.organisationId}/?accounts=1`;
  const [showAudit, setShowAudit] = useState(false);

  return (
    <>
      <Card key={organisation.organisationId}>
        <Card.Body>
          <div className="flex flex-row gap-5 items-center justify-between">
            <div className="flex flex-row gap-5 items-center">
              <div>
                <Avatar
                  imageUrl={
                    organisation.organisationPictureUrl ||
                    "/images/organization-avatar.png"
                  }
                  altText={"Organisation Avatar"}
                  size="md"
                />
              </div>
              <div className="flex flex-col gap-5 justify-between ">
                <div className="flex flex-col gap-2">
                  <span className="text-label-2-bold">
                    {highlightMatchInString(
                      searchValue,
                      organisation.organisationName
                    )}
                  </span>
                  <div className="flex flex-row gap-5 items-center">
                    <span className="text-label-2">
                      {`Accounts: ${organisation.numberOfAccounts}`}
                    </span>
                    <Button
                      variant="link-2"
                      onClick={() => navigate(viewOrganisationAccountsUrl)}
                    >
                      View
                    </Button>
                  </div>
                </div>
                <OrganisationTagsComponent
                  title="Tags: "
                  tags={organisation.tags}
                  onSelected={onTagSelected}
                />
              </div>
            </div>

            <div className="flex flex-row gap-5 items-center">
              <div className="flex flex-row gap-4 items-center">
                <SvgBtn
                  icon={infoBtn}
                  onClick={() => setShowAudit(true)}
                  color="black"
                />
                <span className="text-label-2">Status:</span>
                <Status
                  suspended={organisation?.suspended}
                  archived={organisation?.archived}
                />
              </div>
              <Button
                variant="primary-3"
                onClick={() => navigate(manageProfileUrl)}
              >
                Manage profile
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
      <OrganisationAuditWindow
        organisation={organisation}
        show={showAudit}
        handleClose={() => setShowAudit(false)}
      ></OrganisationAuditWindow>
    </>
  );
};

export default OrganisationItemComponent;
